<nav class="mb-6 w-full" aria-label="Breadcrumb">
  @if (crumbs.length) {
    <ol class="flex w-full items-center gap-2">
      @for (
        crumb of crumbs;
        track crumb;
        let first = $first;
        let last = $last;
        let i = $index
      ) {
        <!-- First item and middle items -->
        @if (!last) {
          <li
            class="flex shrink-0 items-center"
            [ngClass]="{ 'hidden md:flex': !first && !last }"
          >
            <a
              class="max-w-52 truncate text-sm leading-normal font-normal text-neutral-800 hover:text-neutral-600"
              [routerLink]="crumb.url"
              [title]="getLabel(crumb.label) | translate: crumb.params"
            >
              {{
                truncateText(
                  getLabel(crumb.label) | translate: crumb.params,
                  maxLength
                )
              }}
            </a>
            <span class="mx-1 shrink-0 text-neutral-500">&gt;</span>
          </li>
        }
        <!-- Collapse button (only on mobile, after first item) -->
        @if (!first && !last && i === 1) {
          <li class="relative flex shrink-0 items-center md:hidden">
            <button
              class="breadcrumb-toggle flex h-6 w-6 items-center justify-center rounded bg-secondary-background transition-colors hover:bg-neutral-100"
              (click)="toggleDialog($event)"
              type="button"
            >
              <span class="text-neutral-800">...</span>
            </button>
            <span class="mx-1 shrink-0 text-neutral-500">&gt;</span>
            <!-- Dialog for collapsed items -->
            @if (showDialog) {
              <div
                class="breadcrumb-dialog shadow-lg absolute top-full left-0 z-50 mt-1 min-w-52 rounded-lg border border-secondary-border bg-secondary-background p-4"
              >
                <ul class="space-y-1">
                  @for (c of getHiddenCrumbs(); track c) {
                    <li class="rounded transition-colors">
                      <a
                        class="block rounded px-3 py-1 leading-normal font-normal text-neutral-800 hover:bg-white"
                        [routerLink]="c.url"
                        [title]="getLabel(c.label) | translate: c.params"
                        (click)="showDialog = false"
                      >
                        {{ getLabel(c.label) | translate: c.params }}
                      </a>
                    </li>
                  }
                </ul>
              </div>
            }
          </li>
        }
        <!-- Last item -->
        @if (last) {
          <li class="min-w-0 flex-1">
            <span
              class="block truncate leading-normal font-medium text-neutral-800 md:max-w-[20ch]"
              [title]="getLabel(crumb.label) | translate: crumb.params"
            >
              {{ getLabel(crumb.label) | translate: crumb.params }}
            </span>
          </li>
        }
      }
    </ol>
  }
</nav>
